var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{
    warning: _vm.hasWarning,
    caution: _vm.hasCaution,
    'default-bg': !_vm.hasWarning && !_vm.hasCaution,
  }},[_c('span',[_vm._v(_vm._s(_vm.name))]),(_vm.hasWarning || _vm.hasCaution)?_c('div',{staticClass:"info-icon-container"},[_c('vx-tooltip-with-slot-text',{attrs:{"position":"bottom"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('tooltip-crew-assignment-alert',{attrs:{"alerts":_vm.alertInfo}})]},proxy:true},{key:"inner",fn:function(){return [_c('span',{staticClass:"material-icons alert-icon cursor-pointer",class:{
            warning: _vm.hasWarning,
            caution: _vm.hasCaution,
          }},[_vm._v("\n          error\n        ")])]},proxy:true}],null,false,3291248211)})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }